<template>
<div>
  <DataNavigation></DataNavigation>
  <VipPrompt :pageModal="page_modal" @pagecancel="pageCancel"></VipPrompt>
  <div class="index_content">
    <Layout>
      <Sider width="208">
        <div class="right_column">
          <p class="top-tip">财务数据</p>
          <div class="keyword-input">
            <Input search enter-button :placeholder="search_phd" v-model="search_ipt" @on-search="handleSearch($event)" />
          </div>
          <div class="rigit_title">
            <span>筛选</span>
            <Dropdown trigger="click" placement="bottom-start" @on-visible-change="handleDropdown" @on-click="haddleScreenDropdown">
              <a href="javascript:void(0)">
                <span>{{screen_active}}</span>
                <Icon type="md-arrow-dropup" v-if="drop_val" />
                <Icon type="md-arrow-dropdown" v-else />
              </a>
              <DropdownMenu slot="list">
                <DropdownItem v-for="(item, sindex) in screen_dropdown" :name="item" :selected="screen_active == item" :key="sindex">{{item}}</DropdownItem>
              </DropdownMenu>
            </Dropdown>
          </div>
          <div class="rigit_content">
            <div class="screen_ul">
              <div class="screen_li" v-show="screen_active === '全部' || screen_active === '领域选择'">
                <div class="screen_tle" @click="screenTle.tags = !screenTle.tags">
                  <span>领域选择</span>
                  <Icon type="md-add" v-if="!screenTle.tags" />
                  <Icon type="md-remove" v-else />
                </div>
                <div class="screen_cnt" v-show="screenTle.tags">
                  <ul class="scr_attention">
                      <!-- @on-change="handleChangeOption($event, 'tags')" -->
                    <CheckboxGroup v-model="params.tags" @on-change="handleChangeOption($event, 'tags')">
                      <li v-for="tItem in dynview_tag_type" :key="tItem.id">
                        <div class="scr_att_tle">
                          <Icon type="md-arrow-dropright" v-if="!screen_sec[tItem.id]" @click="haddleSecSel(tItem.id)" />
                          <Icon type="md-arrow-dropdown" v-else @click="haddleSecSel(tItem.id)" />
                          <span @click="haddleSecSel(tItem.id)">{{tItem.name}}</span>
                        </div>
                        <div class="scr_att_cnt" v-show="screen_sec[tItem.id]">
                          <Checkbox v-for="item in hot_tag_map" :label="item.id" :key="item.id" v-if="item.type_id === tItem.id">
                            <span>{{item.name}}</span>
                          </Checkbox>
                        </div>
                      </li>
                    </CheckboxGroup>
                  </ul>
                </div>
              </div>
              <div class="screen_li" v-show="screen_active === '全部' || screen_active === '股市选择'">
                <div class="screen_tle" @click="screenTle.m_name = !screenTle.m_name">
                  <span>股市选择</span>
                  <Icon type="md-add" v-if="!screenTle.m_name" />
                  <Icon type="md-remove" v-else />
                </div>
                <div class="screen_cnt" v-show="screenTle.m_name">
                  <RadioGroup v-model="params.m_name" vertical  @on-change="clearGetList($event)">
                    <Radio label="ganggu"><span>港股</span></Radio>
                    <Radio label="hushen"><span>沪深</span></Radio>
                    <Radio label="meigu"><span>美股</span></Radio>
                  </RadioGroup>
                </div>
              </div>
              <div class="screen_li" v-show="screen_active === '全部' || screen_active === '时间选择'">
                <div class="screen_tle" @click="screenTle.year = !screenTle.year">
                    <span>时间选择</span>
                    <Icon type="md-add" v-if="!screenTle.year" />
                    <Icon type="md-remove" v-else />
                </div>
                <div class="screen_cnt" v-show="screenTle.year">
                    <RadioGroup v-model="selTime" vertical @on-change="handleChangeTime($event)">
                        <Radio label=""><span>不限</span></Radio>
                        <Radio v-for="item,index in cw_year" :label="item" :key="index"><span>{{item}}</span></Radio>
                        <Radio label="zdy"><span>自定义</span></Radio>
                    </RadioGroup>
                    <div class="zdy_time" v-if="selTime == 'zdy'">
                      <DatePicker type="date" v-model="params.s_time" placeholder="开始时间" :options="startOptions" @on-change="getEntityList" :clearable="false"></DatePicker>
                      <DatePicker type="date" v-model="params.e_time" placeholder="结束时间" :options="endOptions" @on-change="getEntityList" :clearable="false"></DatePicker>
                    </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Sider>
      <Content>
        <div class="top-tip">全部
          <Dropdown @on-click="haddleChangeSort">
            <a href="javascript:void(0)">{{sort_id | dealName(sort_list)}}<i class="iconfont">&#xe6ea;</i></a>
            <DropdownMenu slot="list">
              <DropdownItem v-for="item in sort_list" :key="item.id" :name="item.id" :disabled="sort_id === item.id">{{item.name}}</DropdownItem>
            </DropdownMenu>
          </Dropdown>
        </div>
        <div class="sel_opt" v-if="haveOption && haveOption.length > 0">
          <div class="sel_tle">已选条件</div>
          <div class="sel_cnt">
            <span v-for="(item,index) in haveOption" :key="index" @click="handleCancelOption(item)">{{item.name}}
              <Icon type="md-close" />
            </span>
          </div>
          <div class="sel_clear">
            <span @click="handleClearOption"><i class="iconfont">&#xe63e;</i>清空筛选</span>
          </div>
        </div>
        <div class="list_div">
          <Table :columns="listColumns" :data="listData"></Table>
          <OrgPrompt which="cwsj" v-if="listData.length == 5"></OrgPrompt>
          <!-- <template v-else>
            <div class="page clear" v-if="total > 10">
              <Page :total="total" :page-size="10" :current="params.page" class="page_list" show-total show-elevator ref="pages" @on-change="handleChangePage" />
            </div>
          </template> -->
          <Spin fix v-if="listLoading">
            <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
            <div>Loading</div>
          </Spin>
        </div>
      </Content>
    </Layout>
  </div>
</div>
</template>

<script>
import {
  getFinanceData
} from '../../service'
import {
  remove
} from 'js/findIndex'
import {
  listMixins
} from 'js/listMixins'
import {
  userInfo
} from 'js/userInfo'
import DataNavigation from './components/DataNavigation.vue'
import OrgPrompt from '@/components/OrgPrompt.vue'
import filter from 'js/filter'
import moment from 'moment'

export default {
  inject: ['login'],
  mixins: [listMixins, userInfo],
  components: {
    DataNavigation,
    OrgPrompt
  },
  data() {
    return {
      listName: '财务数据',
    //   entity_list: [],
      listColumns: [
        {
          title: '公司名称',
          width: 170,
          render: (h, params) => {
            if(params.row.info.uid) {
                if(params.row.info.type == '0'
                ||params.row.info.type == '1'
                ||params.row.info.type == '2'
                ||params.row.info.type == '3'){
                    return h('a',{
                    on: {
                        click: () => {
                        this.goEntityDetail(params.row.info.uid, params.row.info.type, { active_name: 'finance' })
                        }
                    },
                    class: {
                        'dec-clamp': true
                    }
                    },  params.row.info.short_name)
                } else {
                    return h('div', params.row.info.short_name)
                }
            } else {
              return h('span', '--')
            }
          }
        },
        {
          title: '公司简介',
          width: 230,
          render: (h, params) => {
            return h('span', params.row.info.description)
          }
        },
        {
          title: '成立时间',
          width: 130,
          render: (h, params) => {
            return h('span', filter.time_moment(params.row.info.setup_time, 'YYYY-MM-DD'))
          }
        },
        {
          title: '上市市场',
          width: 100,
          render: (h, params) => {
            return h('span', this.params.m_name?this.m_name_k_v[this.params.m_name]:'港股')
          }
        },
        {
          title: '财报更新日期',
          width: 146,
          render: (h, params) => {
            return h('span', params.row.date_type_time)
          }
        },
        {
          title: '财务报表',
          render: (h, params) => {
            // return h('span', '资产负债表、利润表、现金流量表')
            return h('a',{
              on: {
                  click: () => {
                    this.goEntityDetail(params.row.info.uid, params.row.info.type, { active_name: 'finance' })
                  }
              },
              class: {
                  'dec-clamp': true
              }
            },  '资产负债表、利润表、现金流量表')
          }
        }
      ],
      params: {
        sort_type: '0',
        m_name:"",
        fetch_size:0,
        year:"",
        tags:[],
        keyword:"",
        s_time: '',
        e_time: ''
      },
      screen_dropdown: ['全部', '领域选择', '项目名称', '数据类别', '地区选择','时间选择'],
      //筛选条件是否展开
      screenTle: {
        tags: false,
        m_name: false,
        year: false
      },
      m_name_k_v: {
          'ganggu': '港股',
          'meigu': '美股',
          'hushen': '沪深'
      },

      checkAll: {
        tags: true
      },

      sort_id: 0,
      sort_list: [
        {id: 0, name: '更新日期倒序'},
        {id: 1, name: '更新日期正序'}
      ],

    //   数组
      cw_year: []
    }
  },
  computed: {
    haveOption() {
       let optionTag = [],
        optionMName = [],
        optionYear = [],
        optionKeyword = [],
        optionStart = [],
        optionEnd = []
      this.params.tags.map((a) => {
        optionTag.push({
          type: 'tags',
          name: filter.dealName(a, this.hot_tag_map),
          value: a
        })
      })
      if (this.params.m_name) {
        optionMName = {
          type: 'm_name',
          name: this.m_name_k_v[this.params.m_name],
          value: this.params.m_name
        }
      }
      if (this.params.year != '' && this.selTime != 'zdy') {
        optionYear = {
          type: 'year',
          name: this.params.year,
          value: this.params.year
        }
      }
      if (this.params.s_time != '') {
        optionStart = {
          type: 's_time',
          name: '开始时间：' + filter.time_moment(this.params.s_time),
          value: this.params.s_time
        }
      }
      if (this.params.e_time != '') {
        optionEnd = {
          type: 'e_time',
          name: '结束时间：' + filter.time_moment(this.params.e_time),
          value: this.params.e_time
        }
      }
      if (this.params.keyword) {
        optionKeyword = {
          type: 'keyword',
          name: this.params.keyword,
          value: this.params.keyword
        }
      }

      return [].concat(
        optionTag,
        optionMName,
        optionYear,
        optionKeyword,
        optionStart,
        optionEnd
      )
    }
  },
  methods: {
    /**
     * 获取公司列表
     */
    async getEntityList() {
      this.params.user_key = this.user_key
      this.params.sort_type = this.sort_id
      if(this.params.s_time) {
        this.params.s_time = moment(this.params.s_time).format('YYYY-MM-DD')
      }
      if(this.params.e_time) {
        this.params.e_time = moment(this.params.e_time).format('YYYY-MM-DD')
      }
      this.listLoading = true
      let res = await getFinanceData(this.params, (error) => {
        this.$Message.error('请求错误！')
      })
      if (res.status == 'success') {
        this.$set(this.$data, 'listData', res.res)
        res.res.forEach((item) => {
            item.info = res.entity_info.find(t => t.comp_stock_id == item.comp_stock_id) || {}
        })
        // this.entity_list = res.entity_info
        if (this.params.page == 1) {
            this.$set(this.$data, 'total', res.count)
        }
        this.listLoading = false
      } else {
        this.$Message.error(res.message)
      }
    },
    /**
     * 清空已选择项
     */
    handleClearOption() {
      this.params = {
        m_name:"",
        fetch_size:0,
        year:"",
        tags:[],
        keyword:"",
        sort_type: '0',
        s_time: '',
        e_time: ''
      }
      this.search_ipt = ''
      this.selTime = ''
      this.params.page = 1
      this.getEntityList()
    }
  },
  created() {
    this.getMeta(true)
    for(let i=moment().format('YYYY');i>=2015;i--) {
        this.cw_year.push(i)
    }
    this.getEntityList()
  },
  mounted() {
    this.$nextTick(() => {
      window.onscroll = () => {
        this.listenerScroll('right_column', 10)
      }
      window.onresize = () => {
        this.listenerScroll('right_column', 10)
      }
    })
  },
  destroyed() {
    window.onscroll = ''
    window.onresize = ''
  },
  beforeDestroy() {
    // this.$store.commit('updateOrgParams', this.params)
  }
}
</script>

<style lang="stylus" scoped>
@import '~styles/common.stylus'
@import '~styles/dataList.stylus'
</style>
